import ApiBase from './api-base'
import {PUBLIC} from './constants'
export default class Files extends ApiBase {
  constructor (store) {
    const path = PUBLIC + '/file'
    super(store, path)
  }

  upload (files, onUploadProgress, showProgress) {
    const formData = new FormData()

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      formData.append('files', file, file.name)
    }

    return this._request({
      action: 'temp/upload',
      method: 'POST',
      form: formData,
      onUploadProgress,
      showProgress
    })
  }

  delete (fileName, showProgress) {
    return this._request({
      action: `temp/${this._urlencode(fileName)}`,
      method: 'DELETE',
      showProgress
    })
  }

  uploadFile(model) {
    return this._request({
      action: 'temp/upload',
      method: 'POST',
      body: model
    })
  }
}
